export default "__VITE_ASSET__Bn6j_9xZ__"